<template>
  <div class="sectionBox2">
    <div class="topBox">
      <van-nav-bar
        title="商品详情"
        style="background: linear-gradient(45deg, #75b9ff, #1b8bff)"
        left-arrow
        @click-left="onClickLeft"
      />
    </div>
    <div class="conBox">
      <div style="min-height: 200px; background: #fff">
        <el-image
          style="width: 100%; height: auto; min-height: 200px"
          :src="shopUrls"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <i
              class="el-icon-picture-outline"
              style="font-size: 36px; color: #b5b5b5; line-height: 200px"
            ></i>
          </div>
        </el-image>
      </div>
      <div class="box_item">
        <div class="line01">
          <div class="left">
            <div style="color: #1b8bff">
              ￥
              <span v-if="detailInfo.shopDivideModel" style="font-size: 20px">
                {{ detailInfo.shopDivideModel.shopPrice }}
              </span>
              <span v-else style="font-size: 20px">
                {{ detailInfo.shopPrice ? detailInfo.shopPrice : 0 }}
              </span>
              <span
                v-if="detailInfo.shopDivideModel"
                style="font-size: 12px; text-decoration: line-through"
              >
                {{ detailInfo.shopDivideModel.shopOriginPrice }}
              </span>
              <span
                v-else
                style="font-size: 12px; text-decoration: line-through"
              >
                {{
                  detailInfo.shopOriginPrice ? detailInfo.shopOriginPrice : 0
                }}
              </span>
            </div>
            <div class="titles1" @click="pos">
              {{ detailInfo.shopName ? detailInfo.shopName : "---" }}
            </div>
            <div class="titles2">
              {{ detailInfo.shopTitle ? detailInfo.shopTitle : "---" }}
            </div>
          </div>
          <div class="right" @click="serviceBtn">
            <el-image
              class="images"
              :src="require('../../assets/kf.png')"
              fit="fill"
            ></el-image>
            <div class="btn_text">客服</div>
          </div>
        </div>
        <div class="line02">
          <div class="num1">
            快递费:
            <span v-if="detailInfo.shopDivideModel">
              {{ detailInfo.shopDivideModel.shopPostAge }}元
            </span>
            <span v-else>
              {{ detailInfo.shopPostAge ? detailInfo.shopPostAge : 0 }}元
            </span>
          </div>
          <div class="num2">
            商品销量:
            {{
              detailInfo.fakeSales > 0
                ? detailInfo.fakeSales
                : detailInfo.outNumber
            }}个
          </div>
        </div>
      </div>
      <div class="detailBox">
        <div class="mainBoxs">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="商品详情" name="first"></el-tab-pane>
            <el-tab-pane label="流量详情" name="second"></el-tab-pane>
          </el-tabs>
        </div>
        <div style="text-align: center; padding: 5px 0px">
          <div
            v-if="activeName == 'first'"
            style="text-align: left"
            v-html="detailInfo.shopContent"
            class="shopContents"
          ></div>
          <div v-else>
            <table
              border="1"
              bordercolor="#d5d5d5"
              style="border-collapse: collapse"
              width="100%"
            >
              <tr>
                <td colspan="2" style="border: solid 1px #d5d5d5; height: 30px">
                  流量详情
                </td>
              </tr>
              <tr v-for="items of detailInfo.shopFlowList" :key="items.id">
                <td style="border: solid 1px #d5d5d5; height: 30px">
                  {{ items.flowPrice }}元
                </td>
                <td style="border: solid 1px #d5d5d5; height: 30px">
                  {{ items.flowContent }}G
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="buyBox">
      <el-button class="btns" @click="buyBtn">立即购买</el-button>
    </div>
    <!-- 联系客服 -->
    <van-overlay
      :show="serviceDialog"
      @click="serviceDialog = false"
      z-index="11"
    >
      <div class="wrappers1">
        <div class="blocks1" @click.stop>
          <div class="tit1">联系客服</div>
          <div style="margin: 20px 0px 5px">
            <el-image
              style="width: 200px; height: 200px"
              :src="serviceInfo.imgUrl ? serviceInfo.imgUrl : ''"
            ></el-image>
          </div>
          <div class="tit2">
            {{ serviceInfo.content ? serviceInfo.content : "" }}
          </div>
          <div v-if="serviceInfo.weChatNumber">
            <van-field
              v-model="serviceInfo.weChatNumber"
              class="inputDiv"
              label
              placeholder="客服微信号"
              readonly
            >
              <template #button>
                <span
                  style="color: #409eff"
                  @click="copyWeChatNumber(serviceInfo.weChatNumber)"
                >
                  复制
                </span>
              </template>
            </van-field>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import { getShopAdminModel, shopCustomerModel } from "@/api/shopping";
  export default {
    data() {
      return {
        detailInfo: {},
        shopUrls: "",
        activeName: "first",
        serviceDialog: false,
        serviceInfo: {},
      };
    },
    mounted() {
      if (this.$route.query.id) {
        localStorage.setItem("shopDetailId", this.$route.query.id);
      }
      if (this.$route.query.userId) {
        localStorage.setItem("userIds", this.$route.query.userId);
      }
      this.getShopAdminModel();
    },
    created() {},
    methods: {
      // 返回
      onClickLeft() {
        localStorage.setItem("shopDetailId", "");
        history.back();
      },
      handleClick(tab, event) {
        console.log(tab.index, event);
      },
      // =================================
      // 联系客服
      serviceBtn() {
        this.shopCustomerModel();
      },
      shopCustomerModel() {
        var meCardNum = "";
        var userId = "";
        if (this.$route.query.id || this.$route.query.userId) {
          meCardNum = "";
          if (this.$route.query.userId) {
            userId = this.$route.query.userId;
          }
        } else {
          if (localStorage.getItem("meCardNum") != undefined) {
            meCardNum = localStorage.getItem("meCardNum");
          }
          if (localStorage.getItem("userIds") != undefined) {
            userId = localStorage.getItem("userIds");
          }
        }
        shopCustomerModel(userId, meCardNum).then((res) => {
          if (res.status) {
            //  console.log(res.data)
            if (res.data && res.data.length > 0) {
              this.serviceInfo = res.data[0];
              if (this.serviceInfo.type == 0) {
                window.location.href = this.serviceInfo.customerUrl;
              } else {
                this.serviceDialog = true;
              }
            } else {
              this.serviceInfo = {};
              this.$notify({ type: "warning", message: "管理员暂未设置客服" });
            }
          }
        });
      },
      // 复制
      copyWeChatNumber(val) {
        // console.log(val);
        let input = document.createElement("input");
        input.value = val;
        input.id = "creatDom";
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        // ===========================
        this.$notify({ type: "success", message: "复制成功!" });
      },
      // ==================================
      // 查询订单详情
      getShopAdminModel() {
        var cards = "";
        var userId = "";
        if (this.$route.query.id || this.$route.query.userId) {
          cards = "";
          localStorage.removeItem("meCardNum");
          if (this.$route.query.userId) {
            userId = this.$route.query.userId;
          }
        } else {
          if (localStorage.getItem("userIds") != undefined) {
            cards = "";
            userId = localStorage.getItem("userIds");
          } else {
            cards = localStorage.getItem("meCardNum");
            userId = "";
          }
        }

        let params = {
          id: Number(localStorage.getItem("shopDetailId")),
          meCardNum: cards,
          userId: userId,
        };
        getShopAdminModel(params).then((res) => {
          if (res.status) {
            if (res.data) {
              this.detailInfo = res.data;
              this.shopUrls = res.data.shopUrl;
            }
          }
        });
      },
      pos() {
        this.$toast({
          message: `${this.detailInfo.shopName}`,
          position: "top",
        });
      },
      // 立即购买
      buyBtn() {
        this.$router.push(`/buys`);
      },
    },
  };
</script>
<style lang="scss">
  .van-nav-bar .van-icon {
    color: #fff;
  }
  .van-nav-bar__title {
    color: #fff;
  }
</style>

<style lang="scss">
  .sectionBox2 {
    height: 100vh;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    .topBox {
      width: 100%;
      position: fixed;
      top: 0px;
      z-index: 10;
      height: 46px;
    }
    .conBox {
      clear: both;
      position: relative;
      top: 46px;
      background-color: #f5f5f5 !important;
      height: calc(100% - 76px);
      padding-bottom: 30px;
      // padding: 20px 15px;
      z-index: 1;
      overflow: auto;
      .box_item {
        margin: 10px 10px;
        // min-height: 120px;
        border-radius: 10px;
        background-color: #fff;
        padding: 10px 15px;
        .line01 {
          padding-bottom: 10px;
          border-bottom: 1px solid #d5d5d5;
          .left {
            display: inline-block;
            width: calc(100% - 50px);
            text-align: left;
            .titles1 {
              font-size: 14px;
              color: #525252;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .titles2 {
              font-size: 12px;
              color: #959595;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .right {
            display: inline-block;
            width: 50px;
            text-align: center;
            .images {
              width: 25px;
              height: 25px;
            }
            color: #333333;
            font-size: 14px;
          }
        }
        .line02 {
          padding: 10px 15px 0px;
          .num1 {
            display: inline-block;
            width: 50%;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .num2 {
            display: inline-block;
            margin-left: 1%;
            width: 49%;
            text-align: right;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .detailBox {
        margin: 10px 10px 30px;
        min-height: 120px;
        border-radius: 10px;
        background-color: #fff;
        padding: 10px 15px;
        .mainBoxs {
          margin: 0px;
          padding: 0px;
          background-color: #fff !important;
          .el-tabs__header {
            margin-bottom: 5px;
          }
          .el-tabs__nav-scroll {
            text-align: center !important;
          }
          .el-tabs__nav,
          .is-top {
            clear: both !important;
            display: inline-block !important;
          }

          .el-tabs__nav-wrap::after {
            background-color: transparent !important;
          }
          .el-tabs__content {
            display: none;
            // background-color: #f5f5f5 !important;
            // padding: 10px !important;
            // height: 100vh;
          }
        }
        .shopContents {
          width: 100%;
          img {
            width: 100%;
          }
        }
      }
    }
    .buyBox {
      position: fixed;
      bottom: 0px;
      width: calc(100% - 20px);
      text-align: center;
      padding: 10px;
      z-index: 10;
      // background: #fff;
      .btns {
        width: 100%;
        color: #fff;
        background: linear-gradient(45deg, #75b9ff, #0096ff);
        border-radius: 10px;
      }
    }
    .wrappers1 {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      .blocks1 {
        width: calc(100% - 50px);
        background-color: #fff;
        border-radius: 10px;
        padding: 15px 10px;
        .tit1 {
          font-size: 18px;
          color: #515151;
        }
        .tit2 {
          font-size: 14px;
          color: #515151;
        }
        .inputDiv {
          margin-top: 10px;
          border-radius: 10px;
          background-color: #f5f5f5;
        }
      }
    }
  }
</style>
